import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/studios/equipment-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StudioCard"] */ "/app/components/admin/studios/studio-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/studios/studio-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StudioFormDialog"] */ "/app/components/admin/studios/studio-form-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/studios/studio-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/studios/studio-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/studios/studios-page-client.tsx");
